import type { ReactNode } from "react";
import { useTranslation } from "@i18n";
import IconComponent from "@CubeComponents/icons";
import Text from "@CubeComponents/html/Text/Text";

interface CentralPropertiesProps {
  selectedRows: number;
  children: ReactNode;
  noSelectionMessage?: string;
  multipleSelectionMessage?: string;
  width?: string;
}

const CentralProperties = ({
  selectedRows,
  children,
  noSelectionMessage,
  multipleSelectionMessage,
  width = "40rem",
}: CentralPropertiesProps) => {
  const { t } = useTranslation();

  const message =
    selectedRows === 0
      ? (noSelectionMessage ?? t("No file selected"))
      : (multipleSelectionMessage ?? t("Multiple Files Selected"));

  return (
    <div style={{ width }} className="flex h-full border border-[#C6D8EC] rounded-lg bg-white">
      {selectedRows === 1 ? (
        children
      ) : (
        <div className="flex w-full h-full items-center justify-center flex-col gap-4">
          <IconComponent name="NoData" width="18.75rem" height="18.8125rem" className="w-[15rem] h-[15rem]" />
          <Text sx={{ textAlign: "center" }}>{message}</Text>
        </div>
      )}
    </div>
  );
};

export default CentralProperties;
